import { BaseAuthService } from "../base/baseApiAuth";

export class InvitadoService extends BaseAuthService {
  async tokenInvitado() {
    try {
      const { data } = await this.axiosClient.post(`users/tokenInvitado`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in crearPostulacion with stack: ${error}`);
    }
  }

  async validateToken(token: any) {
    try {
      const { data } = await this.axiosClient.get(`users/token/${token}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in crearPostulacion with stack: ${error}`);
    }
  }
}

export default new InvitadoService();